import { switchSize } from '@/features/ui/inputs/components/Switch/constants'
import Knob from '@/features/ui/inputs/components/Switch/parts/Knob'
import Slide from '@/features/ui/inputs/components/Switch/parts/Slide'
import { SwitchProps } from '@/features/ui/inputs/components/Switch/types'
import { FC } from 'react'
import { Pressable, StyleSheet } from 'react-native'

const Switch: FC<SwitchProps> = ({ checked, onChange, disabled = false, style }) => {
    const handlePress = () => {
        onChange(!checked)
    }

    return (
        <Pressable disabled={disabled} onPress={handlePress} style={[styles.container, style]}>
            <Slide checked={checked} disabled={disabled} />
            <Knob checked={checked} disabled={disabled} />
        </Pressable>
    )
}

const styles = StyleSheet.create({
    container: {
        ...switchSize,
        flexShrink: 0,
        justifyContent: 'center',
    },
})

export default Switch
